var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"fixed-top d-flex justify-content-center align-items-center",attrs:{"id":"navigation-bar"}},[_vm._t("default"),_vm._v(" "),_c('img',{staticClass:"h-100 py-3",attrs:{"id":"navigation-bar-logo","src":"/images/imagotipo-sticky.svg","alt":"","height":"2.5rem","hidden":""}}),_vm._v(" "),_c('customer-area-button',{attrs:{"data-unavailable":""}})],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d5d76ec","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/NavigationBar.vue
// module id = nD/O
// module chunks = 0